<button mat-icon-button type="button" (click)="$sortOrder.next()">
  <ng-container *ngIf="(sortOrder$ | async) as order">
    <ng-container *ngIf="order < 0; else descending">
      <mat-icon svgIcon="sort2"></mat-icon>
    </ng-container>
    <ng-template #descending>
      <mat-icon svgIcon="sort"></mat-icon>
    </ng-template>
  </ng-container>
</button>
